import styled from "styled-components";
import PlaceSVG from "../../../../assets/icons/place.svg";
import Icon from "../../../../components/icon";
import { theme } from "../../../../helpers/theme";
import { Container, MpImg } from "./comonStyles";
import { 
  ServicesContianer, 
  ServicesHeader, 
  ServicesHeaderContainer, 
  ServicesSubHeader, 
} from "./itemListStyles";

const StoringPlace = () => {
  return ( 
    <>
      <Container>
        
        <ServicesContianer>
          <ServicesHeaderContainer>
            <ServicesHeader>Miejsce</ServicesHeader>
            <ServicesSubHeader>Niezależnie od tego, czy potrzebujesz magazynu dedykowanego, czy preferujesz 
magazynowanie rozproszone, nasze usługi są dostosowane do Twoich indywidualnych 
potrzeb. Dzięki nam możesz działać wydajniej i bardziej efektywnie, zawsze mając kontrolę 
nad przestrzenią magazynową.</ServicesSubHeader>
          </ServicesHeaderContainer> 
        </ServicesContianer>
        <MpImg src={PlaceSVG}/>
        {/* <IconContainer>
          <Icon width="100%" height="100%" icon={<PlaceSVG />} />
        </IconContainer> */}
      </Container>
    </>
  );
}

export default StoringPlace;

const IconContainer = styled.div`
width: 250px;
height: 250px;
margin-bottom: 50px;
margin-top: 20px;

@media ${theme.device.mobileL} {
  width: 300px;
  height: 300px;
}

@media ${theme.device.tablet} {
  width: 430px;
  height: 430px;
}

@media ${theme.device.laptopL} {
  width: 540px;
  height: 540px;
}
`;

